import { useAppSelector } from '../store/rootReducer';
export function useSubscription() {
  return useAppSelector(state => state.actions.subscription);
}